import { render, staticRenderFns } from "./ScrollHolder.vue?vue&type=template&id=684954a0"
import script from "./ScrollHolder.vue?vue&type=script&lang=js"
export * from "./ScrollHolder.vue?vue&type=script&lang=js"
import style0 from "./ScrollHolder.vue?vue&type=style&index=0&id=684954a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports